import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { authHeaders } from '../actions';

const fetchResultsEmailSendout = async (surveyId) => {
  const response = await axios.get(
    `/api/dashboard/asq_surveys/${surveyId}/results_parent_email_sendout`,
    { headers: authHeaders() }
  );
  return response.data;
};

const enqueueResultsEmailSendout = async (surveyId) => {
  const response = await axios.post(
    `/api/dashboard/asq_surveys/${surveyId}/results_parent_email_sendout`,
    {},
    { headers: authHeaders() }
  );
  return response.data;
};

// The endpoint rejects surveys ASQ has not scored yet with a 422, so the caller
// has to be told: without an onError the rejection is swallowed and the admin
// sees the confirmation modal close as if the email went out.
export const useAsqResultsEmailSendout = (surveyId, { onError } = {}) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['asqResultsEmailSendout', surveyId],
    queryFn: () => fetchResultsEmailSendout(surveyId),
    enabled: false,
  });

  const mutation = useMutation({
    mutationFn: () => enqueueResultsEmailSendout(surveyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['asqResultsEmailSendout', surveyId] });
    },
    onError: (error) => {
      if (!onError) return;

      const errors = error?.response?.data?.errors;
      onError(errors?.join(', ') || error?.message || 'Unknown Error');
    },
  });

  return {
    sendoutData: query.data,
    isLoadingSendouts: query.isLoading && query.fetchStatus !== 'idle',
    refetchSendouts: query.refetch,
    enqueueEmail: mutation.mutate,
    isEnqueuing: mutation.isPending,
  };
};
